import { Chip, Grid, Stack, Typography } from "@mui/material"
import React from "react"
import {
  IProductPricePaymentInstallment,
  TPaymentMethodEnum,
  TProductFrequency,
  TProductTypePayment,
} from "../../../../../core/types/Product"
import Convertions from "../../../../../core/functions/convertions"
import NumberFunctions from "../../../../../core/functions/NumberFunctions"
import { useCheckoutContext } from "../../../../../core/hooks/useCheckoutContext"

interface IOrderProduct8Prop {
  paymentMethodType: number
  installmentNumber: number
  description: string
  value: number
  defaultValue: number
  installments?: IProductPricePaymentInstallment[] | null
  subtitle?: boolean
  typePayment?: TProductTypePayment
  frequency?: TProductFrequency
}

const paymentsInstallment = [
  TPaymentMethodEnum.CreditCard,
  TPaymentMethodEnum.TwoCreditCard,
  TPaymentMethodEnum.CreditCardAndPix,
]

const paymentsValue = [
  TPaymentMethodEnum.TwoCreditCard,
  TPaymentMethodEnum.CreditCardAndPix,
]

const OrderItem8 = ({
  paymentMethodType,
  installmentNumber,
  description,
  value,
  installments,
  subtitle,
  defaultValue,
  typePayment,
  frequency,
}: IOrderProduct8Prop) => {
  const { productPrice, installment } = useCheckoutContext()

  const isSignature = typePayment === TProductTypePayment.RecurringSubscription
  const isInstallment = paymentsInstallment.includes(paymentMethodType)

  if (isInstallment) {
    const isShowValue = !paymentsValue.includes(paymentMethodType) || subtitle

    let installmentValue = defaultValue

    if (installments && installments !== null) {
      const installment = installments.find(
        (i) => i.installmentNumber === installmentNumber
      )
      if (installment) {
        installmentValue = installment.value
      }
    }

    var complementValue = ""
    const frequencyString = isSignature
      ? Convertions.productFrequencyToType(frequency)
      : ""
    if (frequencyString !== "") {
      complementValue = `/${frequencyString}`
    }

    const installmentNumbers = installment?.original?.map(
      (pi) => pi.installmentNumber
    ) ?? [0]
    const maxInstallment = Math.max(...installmentNumbers)
    const installmentLast = installment?.original?.find(
      (pi) => pi.installmentNumber === maxInstallment
    )

    return (
      //credit card
      <Grid container key={Convertions.replaceSpacesAndNewlines(description)}>
        <Grid item xs={5}>
          <Stack justifyContent="center" height="100%" sx={{ pl: 1 }}>
            <Typography fontSize="14px" lineHeight="18px" fontWeight={400}>
              {description}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={7}>
          <Stack sx={{ pr: 1 }}>
            <Stack
              direction={{ xs: "column-reverse", sm: "row" }}
              spacing={1}
              alignContent={{ xs: "end", sm: "center" }}
              alignItems={{ xs: "end", sm: "center" }}
              justifyContent="end"
            >
              {isSignature && !subtitle && (
                <Chip
                  label="Assinatura"
                  variant="outlined"
                  size="small"
                  sx={{ borderRadius: "32px", gap: "10px", color: "#707275" }}
                  style={{
                    borderColor: "#D8D9FF",
                    fontSize: "14",
                    lineHeight: "18px",
                  }}
                />
              )}

              {isShowValue && (
                <Typography
                  fontSize={subtitle ? "14px" : "14px"}
                  lineHeight={subtitle ? "18px" : "18px"}
                  fontWeight={subtitle ? 600 : 400}
                >
                  {`${installmentNumber}x de ${NumberFunctions.formatMoneyDefault(
                    installmentValue
                  )}${complementValue}`}
                  *
                </Typography>
              )}
            </Stack>
            {(installmentLast?.installmentNumber ?? 0) > 1 && (
              <Typography
                //color="#707275"
                fontWeight={400}
                textAlign="right"
                sx={{ fontSize: "12px", lineHeight: "16px" }}
              >
                OU {NumberFunctions.formatMoneyDefault(value)} À VISTA
              </Typography>
            )}
          </Stack>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid container>
      <Grid item xs={5}>
        <Typography
          fontSize="14px"
          lineHeight="18px"
          fontWeight={400}
          sx={{ pl: 1 }}
        >
          {description}
        </Typography>
      </Grid>
      <Grid item xs={7}>
        <Typography
          textAlign="right"
          fontSize={subtitle ? "14px" : "14px"}
          lineHeight={subtitle ? "18px" : "18px"}
          fontWeight={subtitle ? 600 : 400}
          color={value < 0 ? "#EA5455" : "#343948"}
          sx={{ pr: 1 }}
        >
          {NumberFunctions.formatMoneyDefault(value)}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default OrderItem8
